import { PostRow } from '../../../generated/api/post-row'
import { IPostModel } from '../../../interfaces/models/posts.interfaces'
import { ProcessedDocument } from '../../../types/document-upload'
import { ProcessedMedia } from '../../../types/image-upload'

export type PostAttachments = Pick<PostRow, 'media' | 'documents' | 'polls'>

export interface AttachmentSeed {
  images: ProcessedMedia[]
  documents: ProcessedDocument[]
  preservedMedia: string[]
  preservedDocuments: string[]
}

export const orderedIds = (
  stored: string[] | undefined,
  preserved: string[],
  current: (string | undefined)[]
): string[] => {
  const kept = new Set([...preserved, ...current])
  const storedIds = stored ?? []
  return [
    ...storedIds.filter((id) => kept.has(id)),
    ...current.filter(
      (id): id is string => id !== undefined && !storedIds.includes(id)
    ),
  ]
}

export const seedAttachments = (
  post: Pick<IPostModel, 'media' | 'documentsIds'> | undefined,
  attachments: PostAttachments | undefined
): AttachmentSeed => {
  const seed: AttachmentSeed = {
    images: [],
    documents: [],
    preservedMedia: [],
    preservedDocuments: [],
  }
  post?.media?.forEach((id) => {
    const media = attachments?.media.find((item) => item.id === id)
    if (media) {
      seed.images.push({ id, uploading: false, uri: media.url })
    } else {
      seed.preservedMedia.push(id)
    }
  })
  post?.documentsIds?.forEach((id) => {
    const document = attachments?.documents.find((item) => item.id === id)
    if (document) {
      seed.documents.push({
        id,
        uploading: false,
        name: document.name,
        uri: document.filename,
      })
    } else {
      seed.preservedDocuments.push(id)
    }
  })
  return seed
}
